import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { ListComponent } from '../../shared/list/list.component';
import { BaseUserListComponent } from '../base-user-list/base-user-list.component';

@Component({
  selector: 'app-connection-list',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./connection-list.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class ConnectionListComponent extends BaseUserListComponent implements OnInit, OnChanges {

  @Input() serviceType: string;
  // period: number = 0;
  // firstPeriod: number = 0;
  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.entity = 'radacct';
    this.title = 'usage_report';
  }

  // getApi(): string {
  //   return 'api/user/connectionLog';
  // }

  getBody(): any {
    const body = super.getBody();
    if (body.query) {
      body.query = [body.query, 'and', ['username', '=', this.userid]];
    } else {
      body.query = ['username', '=', this.userid];
    }
    // body['username'] = this.userid;
    // body['period'] = this.period;
    return body;
  }

  getMeta(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.subtitle = `_${this.serviceType}`;
      const meta = await super.getMeta();
      if (this.role === 'USER') {
        meta.columns = meta.columns.filter(c => c.name !== 'framedipaddress'
          && c.name !== 'calledstationid'
          && c.name !== 'callingstationid'
          && c.name !== 'imei'
          && c.name !== 'nasipaddress');
      }

      if (this.serviceType === 'VPS') {
        meta.columns = meta.columns.filter(c => [
          'radacctid',
          'acctstarttime',
          'acctsessiontime',
          'acctstoptime',
          'acctoutputoctets',
          'acctinputoctets',
          'usage'
        ].includes(c.name));
      }

      resolve(meta);

    });

  }

  openLog(radacctid) {
    const log = this.activeModal.open(ListComponent, { size: 'xl' });
    log.componentInstance.chartType = 'line';
    log.componentInstance.entity = 'radacct_snapshot';
    log.componentInstance.title = 'connection_detail';
    log.componentInstance.filter['query'] = ['radacctid', '=', radacctid];
  }

  // async perform(action, row) {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       switch (action.name.toLowerCase()) {
  //         case 'prev_period':
  //           this.prevPriod();
  //           break;
  //         case 'next_period':
  //           this.nextPriod();
  //           break;

  //         default:
  //           await super.perform(action, row);
  //           resolve(true);
  //           break;
  //       }
  //     } catch (error) {
  //       reject(error);
  //     }
  //   });
  // }
  // async perform(action, row) {
  //   if (action.component && action.component === 'connection-detail') {
  //     this.openLog(row.radacctid);
  //   } else {
  //     await super.async perform(action, row);
  //   }

  // }

  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes.userid && this.meta) {
  //     // this.period = 0;
  //     // this.firstPeriod = 0;
  //     this.pageTitle = `${this.selectedAccount ? this.selectedAccount : this.translator.instant('APP_NAME')} :: ${this.userid || ''} :: ${this.meta.caption}`;
  //     this.load();
  //   }
  // }

  // prevPriod() {
  //   this.period = this.period - 1;
  //   this.load();
  // }

  // nextPriod() {
  //   this.period = this.period + 1;
  //   this.load();
  // }

  // load(key?, query?) {
  //   this.service.getUsedInvoicesCount(this.userid).subscribe((result: any) => {
  //     this.firstPeriod = -1 * (result.json().count);
  //     this.customActions = [];
  //     if (this.period < 0) {
  //       this.customActions.push({
  //         name: 'NEXT_PERIOD',
  //         title: this.period < -1 ? 'NEXT_PERIOD' : 'CRNT_PERIOD'
  //       });
  //     }
  //     if (this.period > this.firstPeriod) {
  //       this.customActions.push({
  //         name: 'PREV_PERIOD',
  //         title: 'PREV_PERIOD'
  //       });

  //     }
  //   }, error => {
  //     this.handleError(error);
  //   });

  //   super.load(key, query);
  // }

  rowDoubleClick(e) {
    if (this.selectedRows[0] && this.selectedRows[0].radacctid) {
      this.openLog(this.selectedRows[0].radacctid);
    }
  }
}
